export const EngineeringRef = [
    {
        ref: 'Carneiro, W., Castro, T., Orlando, T., Meurer, F., PAula, D., Virote, B., Vianna, A., & Murgas, L. (2020). Replacing fish meal by Chlorella sp. meal: Effects on zebrafish growth, reproductive performance, biochemical parameters and digestive enzymes. Aquaculture, 528. 10.1016/j.aquaculture.2020.735612',
    },
    {
        ref: 'Chiou, P., Lin, C., Perez, L., & Chen, T. (2002). Effect of Cecropin B and a Synthetic Analogue on Propagation of Fish Viruses in Vitro. Marine Biotechnology, 4(3), 294–302. 10.1007/s10126-002-0021-1',
    },
    {
        ref: 'Dong, B., Tang, D., Chew, K., Phuong, T., Ho, H., Tran, T., Nguyen-Sy, T., Thuong, T., Nguyen, P., Huong, T., Nguyen T., & Show, P. (2021). Green biorefinery: Microalgae-bacteria microbiome on tolerance investigations in plants. Journal of Biotechnology, 343, 120-127. 10.1016/j.jbiotec.2021.12.002',
    },
    {
        ref: 'El-Ibiari, N., Ardy, O., Salem, O., & Abdelrahman, A. (2015). Kinetic Study for Growth of Phormedium Sp. and Chlorella Vulgaris. International Journal of ChemTech Research, 8(9), 284-289.',
    },
    {
        ref: 'Enyidi, U. (2017). Chlorella vulgaris as Protein Source in the Diets of African Catfish Clarias gariepinus. Fishes, 2(4), 17. 10.3390/fishes2040017',
    },
    {
        ref: 'Erviana, R., Saengkun, Y., Rungsa, P., Jangpromma, N., Tippayawat, P., Klaynongsruang, S., Daduang, J., & Daduang, S. (2021). Novel Antimicrobial Peptides from a Cecropin-Like Region of Heteroscorpine-1 from Heterometrus laoticus Venom with Membrane Disruption Activity. Molecules, 26(19), 5872. 10.3390/molecules26195872',
    },
    {
        ref: 'Fahad, S., Khan, F., Pandupuspitasari, N., Ahmed, M., Liao, Y., Waheed, M., Sameeullah, M., Darkhshan, Hussain, S., Saud, S., Hassan, S., Jan, A., Jan, M., Wu, C., Chun, M.,, & Huang, J. (2015). Recent developments in therapeutic protein expression technologies in plants. Biotechnology, 37(2), 265-279. 10.1007/s10529-014-1699-7',
    },
    {
        ref: 'Khan, M., Shin, J., & Kim, J. (2018). The promising future of microalgae: current status, challenges, and optimization of a sustainable and renewable industry for biofuels, feed, and other products. Microbial Cell Factories, 17(36). 10.1186/s12934-018-0879-x',
    },
    {
        ref: 'Lakaniemi, A., Intihar, V., Tuovinen, O., & Puhakka, J. (2012). Growth of Chlorella vulgaris and associated bacteria in photobioreactors. Microbial Biotechnology, 5(1), 69-78. 10.1111/j.1751-7915.2011.00298.x',
    },
    {
        ref: 'Lourdes, F., Josefina, R., Ulises, M., & Jesus, M. (2017). Tolerance and nutrients consumption of Chlorella vulgaris growing in mineral medium and real wastewater under laboratory conditions. Open Agriculture, 2, 394-400. 10.1515/opag-2017-0042',
    },
    {
        ref: 'Lupatsch, I., & Blake, C. "Algae alternative: Chlorella studied as protein source in tilapia feeds" Global Seafood Alliance. 3 May 2013. https://www.globalseafood.org/advocate/algae-alternative-chlorella-studied-as-protein-source-in-tilapia-feeds/',
    },
    {
        ref: 'Mishra, B., Felix, L., Basu, A., Kollala, S., Chhonker, Y., Ganesan, N., Murry, D., & Mylonakis, E. (2022). Design and Evaluation of Short Bovine Lactoferrin-Derived Antimicrobial Peptides against Multidrug-Resistant Enterococcus Faecium. Antibiotics, 11(8), 1085. 10.3390/antibiotics11081085',
    },
    {
        ref: 'Rosales-Mendoza, S., Garcia-Silva, I., Gonzalez-Ortega, O., Sandoval-Vargas, J., Malla, A., & Vimolmangkang, S. (2020). The Potential of Algal Biotechnology to Produce Antiviral Compounds and Biopharmaceuticals. Molecules, 25(18). 10.3390/molecules25184049',
    },
    {
        ref: 'Rosano, G., & Ceccarelli, E. (2014). Recombinant protein expression in Escherichia coli: advantages and disadvantages. Front Microbiology, 5(172). 10.3389/fmicb.2014.00172',
    },
    {
        ref: 'Romoli, O., Mukherjee, S., Mohid, A., Dutta, A., Montali, A., Franzolin, E., Brady, D., Zito, F., Bergantino, E., Rampazzo, C., Tettamanti, G., Bhunia, A., & Sandrelli, F. (2019). Enhanced Silkworm Cecropin B Antimicrobial Activity against Pseudomonas Aeruginosa from Single Amino Acid Variation. American Chemical Society, 5(7), 1200-1213. 10.1021/acsinfecdis.9b00042',
    },
    {
        ref: 'Shilling, P. J., Mirzadeh, K., Cumming, A. J., Widesheim, M., Köck, Z., & Daley, D. O. (2020). Improved designs for pet expression plasmids increase protein production yield in escherichia coli. Communications Biology, 3(1). https://doi.org/10.1038/s42003-020-0939-8',
    },
    {
        ref: 'Skjanes, K., Rebours, C., & Lindbald, P. (2013). Potential for green microalgae to produce hydrogen, pharmaceuticals and other high value products in a combined process. Critical Reviewsin Biotechnology, 33(2), 172-215. 10.3109/07388551.2012.681625',
    },
    {
        ref: 'Taylor, R. “Virtual Conference ‘Translating AMR R&D Mapping into Policy and Action’ - Star-IDAZ.” STAR. 6 Jan 2021. https://www.star-idaz.net/2021/01/virtual-conference-translating-amr-rd-mapping-into-policy-and-action/.',
    },
    {
        ref: 'Wang, J., Ma, K., Ruan, M., Wang, Y., Li, Y., Fu, Y., Song, Y., Sun, H., & Wang, J. (2018). A Novel Cecropin B-Derived Peptide with Antibacterial and Potential Anti-Inflammatory Properties. PeerJ, 6. 10.7717/peerj.5369',
    },
    {
        ref: 'Wang, M., Huang, M., Zhang, J., Ma, Y., Li, S., & Wang, J. (2017). A novel secretion and online-cleavage strategy for production of cecropin A in Escherichia coli. Scientific Reports, 7(7368). 10.1038/s41598-017-07411-5',
    },
    {
        ref: 'Wang, M., Zheng, K., Lin, J., Huang, M., Ma, Y., Li, S., Luo, X., & Wang, J. (2018). Rapid and efficient production of cecropin A antibacterial peptide in Escherichia coli by fusion with a self-aggregating protein. BMC Biotechnology, 18(62). 10.1186/s12896-018-0473-7',
    },
    {
        ref: 'Wang, Y., Misto, M., Yang, J., Gehring, N., Yu, X., &amp; Moussian, B. (2021). Toxicity of dithiothreitol (DTT) to drosophila melanogaster. Toxicology Reports, 8, 124–130. https://doi.org/10.1016/j.toxrep.2020.12.014',
    },
    {
        ref: 'Wu, C., Chih, Y., Hsieh, H., Peng, K., Lee, Y., Yip, B., Sue, S., & Cheng, J. (2022). High Level Expression and Purification of Cecropin-like Antimicrobial Peptides in Escherichia Coli. Biomedicines, 10(6), 1351. 10.3390/biomedicines10061351',
    },
]

export const PartsRef =[
    {
        ref: 'Consensus φ10 (T7) promoter (T7pCONS) - Part:BBa_K4241010'
    },
    {
        ref: 'Scar for pMET-T7-RBS - Part:BBa_K4241011'
    },
    {
        ref: 'TIR-2 translation initiation region 2 - Part:BBa_K4241012'
    },
    {
        ref: '6xHis-thrombin-T7Tag - Part:BBa_K4241013'
    },
    {
        ref: 'T7pCONS-TIR-2 - Part:BBa_K4241015'
    },
    {
        ref: 'Enhance-T7pro-RBS-Start-6xHis-T7tag - Part:BBa_K4241016'
    },
    {
        ref: 'Double stop codon - Part:BBa_K4241017'
    },
    {
        ref: 'Mxe_GyrA_Intein with PT linker and ELK16 - Part:BBa_K4241018'
    },
    {
        ref: 'RFP_Mxe_GyrA_Intein_PT_ELK16 - Part:BBa_K4241019'
    },
    {
        ref: 'Cecropin B bacterial expression - Part:BBa_K4241020'
    },
    {
        ref: '6xHis_SUMO_RFP - Part:BBa_K4241023'
    },
    {
        ref: 'Ulp1 N-terminal (SUMO protease) - Part:BBa_K4241025'
    },
    {
        ref: '6xHis_Ulp1 - Part:BBa_K4241026'
    },
    {
        ref: 'Nitrogen Starvation Inducible promoter 1 (Microalgae) - Part:BBa_K4241790'
    },
    {
        ref: 'Nitrogen Starvation Inducible promoter 2 (Microalgae) - Part:BBa_K4241791'
    },
    {
        ref: 'mCherry XL RFP - Part:BBa_K4241792'
    },
    {
        ref: 'Cecropin B Q53 - Part:BBa_K4241793'
    },
    {
        ref: 'TRAmy3D - BBa_K4241794'
    },
    {
        ref: 'Cecropin B (Microalgal Expression) - BBa K4241795'
    },
    {
        ref: 'Ras-related RABF1 Signal Peptide - BBa_K4241796'
    },
    {
        ref: 'Ulp1_Active Domain (Microalgae) - BBa_K4241797'
    },
    {
        ref: 'CvNDI_UTR - BBa_K4241799'
    },
    {
        ref: 'TRAmy3D_UTR - BBa_K4241800'
    },
    {
        ref: 'CvNDI1_Ulp1_TRAmy3D - BBa_K4241801'
    },
    {
        ref: 'CvNDI1_CeB_TRAmy3D - BBa_K4241802'
    },
    {
        ref: 'CvNDI1_Protein generator (microalgae) - BBa_K4241804'
    },
]



export const ResultRef = [
    {
        ref: 'Giacalone, M. J., Gentile, A. M., Lovitt, B. T., Berkley, N. L., Gunderson, C. W., &amp; Surber, M. W. (2006). Toxic protein expression in escherichia coli using a rhamnose-based tightly regulated and tunable promoter system. BioTechniques, 40(3), 355–364. https://doi.org/10.2144/000112112 4'
    },
]